var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartLine',{attrs:{"datasets":_vm.defaultDatasets,"options":_vm.defaultOptions,"labels":_vm.ranges}})
}
var staticRenderFns = []

export { render, staticRenderFns }